"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.favorite.add': '添加到收藏',
    'conversations.favorite.remove': '从收藏中移除',
};
